import { Badge } from '~/components/UI/Badge'
import i18n from '~/i18n'

const AdTypes: React.FC<{ data: Placement }> = ({ data }) => (
  <div className="placements-ad-types">
    {[...new Set(data.formats.map(item => item.type))].map(item => (
      <Badge
        key={item}
        text={i18n.t('common:capitalize', {
          value: i18n.t(`rm:${item}`)
        })}
      />
    ))}
  </div>
)

export default AdTypes
